import { useTheme } from '@/components/ThemeProvider';
import { copyHandler } from '@/lib/handle';
import { useCallback, useState } from 'react';
import { Copy, CopyError, CopySuccess, ISvg } from '../Icon';

interface IProps extends ISvg {
  duration?: number;
  text: string;
}
export default function CopyNode(props: IProps) {
  const { duration = 1500, text, ...attr } = props;
  const [status, setStatus] = useState<'idle' | 'copied' | 'error'>('idle');
  const { theme } = useTheme();

  const copy = useCallback(
    async (e: any, text: string) => {
      try {
        e.stopPropagation();

        await copyHandler(text);
        setStatus('copied');

        const timer = setTimeout(() => {
          setStatus('idle');
        }, duration);

        return () => clearTimeout(timer);
      } catch (err) {
        console.log(err);
        setStatus('error');

        const timer = setTimeout(() => {
          setStatus('idle');
        }, duration);

        return () => clearTimeout(timer);
      }
    },
    [duration, text],
  );

  return status == 'error' ? (
    <CopyError className="!w-[18px] !h-[18px]" {...attr} />
  ) : status == 'copied' ? (
    <CopySuccess className="!w-[18px] !h-[18px]" {...attr} />
  ) : (
    <Copy className="!w-[18px] !h-[18px]" theme={theme} onClick={(e) => copy(e, text)} {...attr} />
  );
}
